const WYSIWYGTable = require('./modules/wysiwyg-table.js');
new WYSIWYGTable();

// Multiselect Dropdown Component (auto-initializes on [data-multiselect="true"])
require('./modules/multiselect-dropdown.js');

// "(opens in new window)" announcement fallback — catches target=_blank
// links injected by 3rd-party widgets (e.g. Curator.io) that bypass the
// PHP the_content filter. Idempotent; safe to run alongside server-side filter.
require('./modules/target-blank-announce.js');